import React from 'react';
import { RecursiveMenu } from '@uncinc/react-drupal-core';
import { useTranslation } from 'react-i18next';

import './style.scss';

const ContactMenu = ({ toggleOverlayOpen }) => {
  const { t } = useTranslation();

  return (
    <div className="Contact">
      <h4 className="Contact__title">{t('general.contactdetails')}</h4>
      <RecursiveMenu
        menuId="contact"
        minLevel={2}
        onClickFunction={() => toggleOverlayOpen()}
      />
    </div>
  );
};

export default ContactMenu;
